import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EncrDecrServiceService } from '../services/encr-decr-service.service';
import { HttpService } from '../services/http.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  user: string;
  pass: string;
  mostrarPass = false;
  constructor(private toastr: ToastrService, private dataServices: HttpService, private router: Router,private encryp: EncrDecrServiceService) { }

  ngOnInit(): void {
  }

  Usuario = { user: "", idUser: 0, idRol: 0, token:''};


  ki = '123456';
  k2 = '$#@$^';
  k3 = '@1ERF';

  fnIngresar() {
    if (this.user == undefined || this.user.length == 0) {
      this.toastr.info('Debe ingresar su usuario');
      return;
    }
    if (this.pass == undefined || this.pass.length == 0) {
      this.toastr.info('Debe ingresar su contraseña');
      return;
    }
    let params = {
      "usuario": this.user,
      "contrasena": this.encryp.set(this.ki + this.k2 + this.k3, this.pass, 'SHA1')
    }
    
   
    
    this.dataServices.login(params).subscribe(async result => {
      console.log("resulta",result)
      if (result['hasError']) {
        let errores = result['errors'];
        let mensaje = errores && errores.length > 0 && errores[0]['descripcion'] ? errores[0]['descripcion'] : 'Las credenciales son incorrectas';
        this.toastr.warning(mensaje);
      } else {
        localStorage.clear();
        this.Usuario.idRol = result['data']['table0'][0]['tipoUsuario'] === 'Administrador' ? 1 : 2;
        this.Usuario.idUser = result['data']['table0'][0]['idUsuario'];
        this.Usuario.user = result['data']['table0'][0]['usuario'];
        this.Usuario.token=result['token'];
       
        localStorage.setItem('Usuario', JSON.stringify(this.Usuario));
        localStorage.setItem('prueba', 'Prueba');
       
        this.router.navigate(['/home'])
      }
    }, error => {
      this.toastr.error('No se pudo conectar con el servidor');
    });


  }
}
